import { render, staticRenderFns } from "./AlteracaoSenhaLite.vue?vue&type=template&id=c55ec164&scoped=true"
import script from "./AlteracaoSenhaLite.vue?vue&type=script&lang=js"
export * from "./AlteracaoSenhaLite.vue?vue&type=script&lang=js"
import style0 from "./AlteracaoSenhaLite.vue?vue&type=style&index=0&id=c55ec164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55ec164",
  null
  
)

export default component.exports